import "./about.css";

const About = () => {
  return (
    <div className="a">
    
        
      <div className="a-right">
        <h1 className="a-title">About Me</h1>
       
        <p className="a-desc">
        HELLO, I'M COURAGE!
I am a frontend developer .

I like building things with a computer. I enjoy creating apps<br></br> that help the user easily access and benefit from its purpose.

I currently study Computer Science at the University of Benin. <br></br> In the past, I've participated in online training programs and internships like the HNG9. Currently, I am open to any remote web developer roles.


        </p>
      
          
       
      </div>
    </div>
  );
};

export default About;